import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import {
  ACTION_TYPE_TO_DEPENDENT_FIELDS_MAPPING,
  ActionTypeFields,
} from '../../TriggersTab.constants';
import RecipientMultiSelectField from '../../common/RecipientMultiSelectField';
import { TriggerAddEditModalFormValues } from '../TriggerAddEditModal.schema';
import TriggerAddEditModalServiceField from './TriggerAddEditModalServiceField';
import TriggerAddEditModalTemplateField from './TriggerAddEditModalTemplateField';
import TriggerAddEditModalTimingField from './TriggerAddEditModalTimingField';

const TriggerAddEditModalActionTypeExtraFields = () => {
  const { t } = useTranslation();
  const { control } = useFormContext<TriggerAddEditModalFormValues>();
  const actionType = useWatch({ control, name: 'actionType' });

  if (!actionType) {
    return null;
  }

  const isRecipientsFieldVisible = ACTION_TYPE_TO_DEPENDENT_FIELDS_MAPPING[
    actionType
  ].includes(ActionTypeFields.RECIPIENTS);

  const isTemplatesFieldVisible = ACTION_TYPE_TO_DEPENDENT_FIELDS_MAPPING[
    actionType
  ].includes(ActionTypeFields.TEMPLATES);

  const isServicesFieldVisible = ACTION_TYPE_TO_DEPENDENT_FIELDS_MAPPING[
    actionType
  ].includes(ActionTypeFields.SERVICES);

  const isTimingFieldVisible = ACTION_TYPE_TO_DEPENDENT_FIELDS_MAPPING[
    actionType
  ].includes(ActionTypeFields.JOB_TIMING);

  return (
    <>
      {isRecipientsFieldVisible && (
        <RecipientMultiSelectField
          actionType={actionType}
          colSmInput={12}
          label={t('pageAutomations.triggers.modal.recipients')}
          labelOnTop
          name="recipientsList"
          required
          requireSelectionForCopyAgency
        />
      )}
      {isTemplatesFieldVisible && <TriggerAddEditModalTemplateField />}
      {isServicesFieldVisible && <TriggerAddEditModalServiceField />}
      {isTimingFieldVisible && <TriggerAddEditModalTimingField />}
    </>
  );
};

export default TriggerAddEditModalActionTypeExtraFields;
